{
  "common.close": "ዝጋ",
  "common.athleteFallback": "አትሌት {id}",
  "splash.title": "{app} — የእንቅስቃሴዎች ተንቀሳቃሽ ምስል",
  "splash.tagline": "ለእርስዎ የ&nbsp;Strava ውሂብ ተንቀሳቃሽ ካርታ",
  "splash.demo": "ማሳያ",
  "tab.query.title": "የ{name} ካርታ",
  "tab.query.heading": "እንቅስቃሴዎችን ፈልግ፦",
  "tab.query.optDays": "የቅርብ ቀናት",
  "tab.query.optActivities": "የቅርብ እንቅስቃሴዎች",
  "tab.query.optIds": "የእንቅስቃሴ መለያዎች",
  "tab.query.optDates": "የቀን ክልል",
  "tab.query.idsPlaceholder": "የእንቅስቃሴ መለያዎችን እዚህ ያስገቡ",
  "tab.query.after": "ከ፦",
  "tab.query.before": "እስከ፦",
  "tab.query.autozoom": "ከመጫን በኋላ ወደ ውጤቱ በራስ-ሰር አጉላ <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> ፈልግ",
  "tab.query.createAccount": "መለያ ይፍጠሩ እና/ወይም ይግቡ።",
  "tab.query.sports": "ስፖርቶች፦",
  "tab.query.allSports": "ሁሉም ስፖርቶች",
  "tab.query.sportsExcept": "ከእነዚህ በስተቀር ሁሉም",
  "tab.query.sportsNone": "ምንም",
  "tab.query.loadingSports": "ስፖርቶችን በመጫን ላይ…",
  "tab.query.sportsFailed": "የዚህን ካርታ ስፖርቶች መጫን አልተቻለም",
  "tab.query.noSports": "እስካሁን ምንም እንቅስቃሴ የለም",
  "tab.activities.title": "የሚታዩ እንቅስቃሴዎች",
  "tab.activities.clearSelection": "ምርጫን አጽዳ",
  "tab.activities.renderSelected": "የተመረጡትን አሳይ",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> ወደ ምርጫው አጉላ",
  "tab.controls.title": "የንብርብር ቅንብሮች",
  "tab.controls.timescale": "የጊዜ መለኪያ <i>&tau;</i>",
  "tab.controls.timescaleHint": "የማጫወቻ ፍጥነት",
  "tab.controls.period": "ዑደት <i>T</i>",
  "tab.controls.periodHint": "እንቅስቃሴ ~ ሞዴል",
  "tab.controls.dotSize": "የነጥብ መጠን",
  "tab.controls.pathWidth": "የመንገድ ስፋት",
  "tab.controls.pathWidthHint": "ዜሮ መንገዶቹን ይደብቃል",
  "tab.controls.colors": "ቀለሞች",
  "tab.controls.colorsHint": "የቀለም ስብስቡን አሽከርክር",
  "tab.controls.shadows": "ጥላዎች",
  "tab.profile.loginTitle": "ግባ",
  "tab.profile.anonNote": "የራስዎን እንቅስቃሴዎች ለማየት እና የHeatflask መለያዎን ለማስተዳደር በStrava ይግቡ።",
  "tab.profile.loginLink": "በStrava ይግቡ",
  "tab.profile.editOnStrava": "መገለጫዎን በStrava ላይ ያርትዑ",
  "tab.profile.indexNote": "ለፈጣን ተደራሽነት የእንቅስቃሴዎችዎን ማጠቃለያዎች እናስቀምጣለን።",
  "tab.profile.viewIndex": "ማውጫውን ይመልከቱ",
  "tab.profile.sharedMaps": "የተጋሩ ካርታዎች",
  "tab.profile.sharedMapsNote": "ጠፍቷል፦ በHeatflask ላይ እንቅስቃሴዎችዎን የሚያዩት እርስዎ ብቻ ነዎት። በርቷል፦ የካርታዎ አገናኝ ያለው ማንኛውም ሰው በStrava ላይ ይፋ ያደረጓቸውን እንቅስቃሴዎች ማየት ይችላል። የግል እንቅስቃሴዎችዎ በሁለቱም ሁኔታ የእርስዎ ብቻ ናቸው። <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">ግላዊነት እንዴት እንደሚሠራ</a>",
  "tab.profile.logout": "ውጣ",
  "tab.profile.deleteAccount": "መለያ ሰርዝ",
  "tab.profile.deleteConfirm": "የHeatflask መለያዎን ይሰርዙ?\n\nይህ የተቀመጡ እንቅስቃሴዎችዎን ያስወግዳል እና Heatflask የStrava ውሂብዎን የማግኘት ፈቃዱን ይሰርዛል። መመለስ አይቻልም።",
  "tab.profile.languageHeading": "ቋንቋ",
  "tab.profile.languageAuto": "ራስ-ሰር",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">ትርጉሞችን ለማረም ወይም አዲስ ለመጨመር ያግዙን!</a>",
  "tab.profile.unitsHeading": "መለኪያዎች",
  "tab.profile.unitsAuto": "ራስ-ሰር",
  "tab.profile.unitsMetric": "ሜትሪክ (ኪ.ሜ፣ ሜ)",
  "tab.profile.unitsImperial": "ኢምፔሪያል (ማይል፣ ጫማ)",
  "tab.profile.textSizeHeading": "የጽሑፍ መጠን",
  "tab.profile.textSmaller": "አሳንስ",
  "tab.profile.textReset": "መደበኛ",
  "tab.profile.textLarger": "አስፋ",
  "tab.profile.mapDefaultsHeading": "የካርታ ነባሪዎች",
  "tab.profile.mapDefaultsNote": "አገናኙ የራሱን ቅንብር የማይወስን ካርታ በከፈቱ ቁጥር በዚህ መሠረታዊ ካርታ፣ የመሬት ገጽታ እና የንብርብር ቅንብሮች ይጀምሩ። የሚያጋሯቸው አገናኞች አሁንም እርስዎ የሚያዩትን በትክክል ያሳያሉ።",
  "tab.profile.mapDefaultsSave": "እንደ ነባሪዎቼ አስቀምጥ",
  "tab.profile.mapDefaultsForget": "እርሳ",
  "tab.info.title": "መረጃ",
  "tab.info.controlsHeading": "መቆጣጠሪያዎች",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + ጎትት",
  "tab.info.shiftDragDesc": "በሳጥን ውስጥ እንቅስቃሴዎችን ይምረጡ። በንክኪ ማያ ገጽ ላይ መጀመሪያ <i class=\"hf-object-group\"></i> ይንኩ፣ ከዚያ በአንድ ጣት ይጎትቱ። በመጨረሻ የተመረጠው እንቅስቃሴ ዝርዝሩን ያሳያል፣ የእንቅስቃሴዎች ዝርዝርም ወደእሱ ይሸብለላል።",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + ጎትት",
  "tab.info.ctrlDragDesc": "ካርታውን በ3D ያሽከርክሩ እና ያዘንብሉ፣ ወይም ሁለት ጣቶችን ይጠቀሙ",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "የጎን አሞሌውን ክፈት ወይም ዝጋ",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "ቀዳሚ ወይም ቀጣይ የጎን አሞሌ ትር",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "የጎን አሞሌውን ዝጋ",
  "tab.info.liveUrlHeading": "ቀጥታ አድራሻ",
  "tab.info.liveUrlDesc": "የካርታው እይታ እና የእንቅስቃሴ ምስሉ ቅንብሮች በገጹ አድራሻ ውስጥ ይቀመጣሉ፣ ስለዚህ ያጋሩት ማንኛውም ሰው ተመሳሳይ እይታ ያያል።",
  "tab.info.videoHeading": "ቪዲዮ ወደ ውጭ መላክ",
  "tab.info.videoDesc": "የ<i class=\"hf-video-camera\"></i> አዝራሩ ተንቀሳቃሽ ምስሉን እንደ MP4 ይቀርጻል፦ ይንኩት፣ ሳጥኑን በሚፈልጉት የካርታ ክፍል ላይ ያስተካክሉ፣ ከዚያ ለመቅረጽ እንደገና ይንኩ። አንድ ሙሉ ዑደት ይቀረጻል፣ ስለዚህ ቪዲዮው ያለ ክፍተት ይደጋገማል፤ ከ{max} ሰከንድ (Strava የሚቀበለው ረጅሙ ቪዲዮ) በላይ የሆነ ዑደት በ{max} ይቆረጣል።",
  "tab.info.contributeHeading": "አስተዋጽኦ ያድርጉ",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> በGitHub ላይ ይደግፉ",
  "tab.info.contactsHeading": "አድራሻዎች",
  "map.basemapAndTerrain": "መሠረታዊ ካርታ እና የመሬት ገጽታ",
  "map.pauseAnimation": "ተንቀሳቃሽ ምስሉን ለአፍታ አቁም",
  "map.resumeAnimation": "ተንቀሳቃሽ ምስሉን ቀጥል",
  "capture.record": "ቪዲዮ ቅረጽ ({period} ሰ. ዑደት)",
  "capture.recordTruncated": "ቪዲዮ ቅረጽ (አንድ ዑደት {period} ሰ. ነው፤ የመጀመሪያዎቹ {max} ሰ. ብቻ ይቀረጻሉ)",
  "capture.recordArea": "በሳጥኑ ውስጥ ያለውን ቦታ ቅረጽ",
  "capture.stop": "መቅረጽ አቁም",
  "capture.selectionTooSmall": "ምርጫው በጣም ትንሽ ነው",
  "capture.saved": "{name} ተቀምጧል ({size})",
  "capture.cancelled": "መቅረጽ ተሰርዟል",
  "capture.failed": "መቅረጽ አልተሳካም፦ {error}",
  "capture.loadingEncoder": "ኢንኮደሩን በመጫን ላይ…",
  "capture.waitingForMap": "ካርታው እስኪጫን በመጠበቅ ላይ…",
  "capture.encoding": "በመቀየር ላይ… {percent}%",
  "capture.finalizing": "በማጠናቀቅ ላይ…",
  "share.title": "የዚህን ካርታ ሊንክ ያጋሩ",
  "share.copied": "ሊንኩ ተቀድቷል",
  "share.copiedUnshared": "ሊንኩ ተቀድቷል — ነገር ግን ካርታዎ አልተጋራም፣ ስለዚህ ሌላ ማንም ሊከፍተው አይችልም። ይህን ለመቀየር «የተጋሩ ካርታዎች»ን ያብሩ።",
  "share.unshared": "ካርታዎ አልተጋራም፣ ስለዚህ ሌላ ማንም ይህን ሊንክ ሊከፍተው አይችልም። ይህን ለመቀየር «የተጋሩ ካርታዎች»ን ያብሩ።",
  "share.copyThis": "ይህን ሊንክ ይቅዱ፦",
  "update.available": "አዲስ የHeatflask ስሪት ይገኛል።",
  "update.reload": "እንደገና ጫን",
  "import.title": "በማስገባት ላይ",
  "import.stop": "አቁም",
  "import.stopping": "በማቆም ላይ…",
  "import.contacting": "ከStrava ጋር በመገናኘት ላይ…",
  "import.countOf": "እንቅስቃሴዎች፦ {received} ከ{total}",
  "import.count": "እንቅስቃሴዎች፦ {received}",
  "import.waitStrava": "በStrava የማውረድ ገደብ ምክንያት እስከ {time} ቆሟል። ይህን ገጽ ክፍት ይተዉት፤ እንደገና መጫን አያፋጥነውም።",
  "import.waitRationed": "የዛሬ ፈጣን ማውረዶች አልቀዋል። የቀሩት በ{time} በዝግታ ይቀጥላሉ። ይህን ገጽ ክፍት ይተዉት።",
  "import.dailyLimit": "የStrava ዕለታዊ የማውረድ ገደብ ተሟልቷል። ከ{time} በኋላ እንደገና ይሞክሩ።",
  "import.dailyRationed": "የዛሬ የStrava ማውረድ ድርሻዎ አልቋል። ከ{time} በኋላ እንደገና ይሞክሩ።",
  "import.noActivitiesYet": "የStrava መለያዎ ገና ምንም እንቅስቃሴ የለውም። በStrava ላይ አንዱን ይቅዱ ወይም ይስቀሉ፣ እዚህ ይታያል።",
  "table.noActivities": "ምንም እንቅስቃሴ የለም",
  "table.untitled": "(ርዕስ የለውም)",
  "activities.pageTitle": "{app} — የእንቅስቃሴዎች ማውጫ",
  "activities.heading": "የእንቅስቃሴዎች ማውጫ",
  "activities.fetching": "እንቅስቃሴዎችን በማምጣት ላይ...",
  "activities.rateLimit": "የStrava የጥያቄ ገደብ ደርሷል፤ በ{time} ይቀጥላል",
  "activities.noData": "ይቅርታ፣ ምንም ውሂብ የለም &#128577;",
  "activities.colServerCache": "መንገዱ በአገልጋዩ ላይ ተቀምጧል (Mongo)",
  "activities.colBrowserCache": "መንገዱ በዚህ አሳሽ ውስጥ ተቀምጧል",
  "activities.cachedServer": "የ{id} መንገድ በአገልጋዩ ላይ ተቀምጧል",
  "activities.notCachedServer": "የ{id} መንገድ በአገልጋዩ ላይ አልተቀመጠም",
  "activities.cachedBrowser": "የ{id} መንገድ በዚህ አሳሽ ውስጥ ተቀምጧል",
  "activities.notCachedBrowser": "የ{id} መንገድ በዚህ አሳሽ ውስጥ አልተቀመጠም",
  "sport.AlpineSki": "የአልፓይን ስኪ",
  "sport.BackcountrySki": "የገጠር ስኪ",
  "sport.Badminton": "ባድሚንተን",
  "sport.Basketball": "የቅርጫት ኳስ",
  "sport.Canoeing": "የታንኳ ቀዘፋ",
  "sport.Cricket": "ክሪኬት",
  "sport.Crossfit": "ክሮስፊት",
  "sport.Dance": "ዳንስ",
  "sport.EBikeRide": "የኤሌክትሪክ ብስክሌት ጉዞ",
  "sport.Elliptical": "ኤሊፕቲካል",
  "sport.EMountainBikeRide": "የኤሌክትሪክ ተራራ ብስክሌት ጉዞ",
  "sport.Golf": "ጎልፍ",
  "sport.GravelRide": "የጠጠር መንገድ ጉዞ",
  "sport.Handcycle": "የእጅ ብስክሌት",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "የእግር ጉዞ",
  "sport.IceSkate": "የበረዶ ላይ ሸርተቴ",
  "sport.InlineSkate": "ኢንላይን ሸርተቴ",
  "sport.Kayaking": "ካያኪንግ",
  "sport.Kitesurf": "ካይትሰርፊንግ",
  "sport.MountainBikeRide": "የተራራ ብስክሌት ጉዞ",
  "sport.NordicSki": "ኖርዲክ ስኪ",
  "sport.Padel": "ፓዴል",
  "sport.PhysicalTherapy": "ፊዚዮቴራፒ",
  "sport.Pickleball": "ፒክልቦል",
  "sport.Pilates": "ፒላተስ",
  "sport.Racquetball": "ራኬትቦል",
  "sport.Ride": "የብስክሌት ጉዞ",
  "sport.RockClimbing": "የአለት መውጣት",
  "sport.RollerSki": "ሮለር ስኪ",
  "sport.Rowing": "ቀዘፋ",
  "sport.Run": "ሩጫ",
  "sport.Sail": "የሸራ ጀልባ",
  "sport.Skateboard": "ስኬትቦርድ",
  "sport.Snowboard": "ስኖውቦርድ",
  "sport.Snowshoe": "የበረዶ ጫማ",
  "sport.Soccer": "እግር ኳስ",
  "sport.Squash": "ስኳሽ",
  "sport.StairStepper": "የደረጃ ማሽን",
  "sport.StandUpPaddling": "ቆሞ መቅዘፍ",
  "sport.Surfing": "ሰርፊንግ",
  "sport.Swim": "ዋና",
  "sport.TableTennis": "የጠረጴዛ ቴኒስ",
  "sport.Tennis": "ቴኒስ",
  "sport.TrailRun": "የዱካ ሩጫ",
  "sport.Velomobile": "ቬሎሞባይል",
  "sport.VirtualRide": "ምናባዊ የብስክሌት ጉዞ",
  "sport.VirtualRow": "ምናባዊ ቀዘፋ",
  "sport.VirtualRun": "ምናባዊ ሩጫ",
  "sport.Volleyball": "ቮሊቦል",
  "sport.Walk": "መራመድ",
  "sport.WeightTraining": "የክብደት ስልጠና",
  "sport.Wheelchair": "ዊልቸር",
  "sport.Windsurf": "ዊንድሰርፊንግ",
  "sport.Workout": "የአካል ብቃት እንቅስቃሴ",
  "sport.Yoga": "ዮጋ"
}
